import { SxProps, Theme } from '@mui/material';

export const CONTRACT_SIDE_PADDING = '5%';
export const CONTRACT_COLUMN_GAP = '10%';

export const contractSectionPaddingSx: SxProps<Theme> = {
  paddingLeft: CONTRACT_SIDE_PADDING,
  paddingRight: CONTRACT_SIDE_PADDING,
};

export const contractGridSx: SxProps<Theme> = {
  ...contractSectionPaddingSx,
  display: 'grid',
  gridTemplateColumns: {
    xs: '1fr',
    sm: 'repeat(2, minmax(0, 1fr))',
  },
  columnGap: CONTRACT_COLUMN_GAP,
  rowGap: 3,
  width: '100%',
  boxSizing: 'border-box',
};

export const contractSubheaderBaseSx: SxProps<Theme> = {
  fontSize: '1.125rem',
  ...contractSectionPaddingSx,
};
